import { TestConfig } from '../types';

const defaultConfig: TestConfig = {
  title: "Post a Job",
  description: "Thank you for providing your feedback. We're developing a feature that will automatically extract job details from job links to streamline posting new positions. We'd appreciate your feedback on this upcoming functionality through a brief self-directed test.",
  
  variants: [
    {
      id: "variant-a",
      name: "Test the guided approach starting with path selection",
      figmaUrl: "https://www.figma.com/embed/5jmgqhtFPWQwGYOmewHK3x/Updating-JPF?node-id=82-2485&embed-host=share&scaling=min-zoom",
      description: "The first design concept for evaluation"
    },
    {
      id: "variant-b",
      name: "Design Variant B",
      figmaUrl: "https://www.figma.com/embed/5jmgqhtFPWQwGYOmewHK3x/Updating-JPF?node-id=17-1292&embed-host=share&scaling=min-zoom",
      description: "The second design concept for evaluation"
    }
  ],
  
  questions: [
    {
      id: "ease-of-use",
      text: "How easy was it to navigate through the interface?",
      type: "likert"
    },
    {
      id: "visual-appeal",
      text: "How visually appealing did you find the design?",
      type: "likert"
    },
    {
      id: "preference",
      text: "Which aspect of the design did you prefer the most?",
      type: "multipleChoice",
      options: [
        "Layout and organization",
        "Color scheme",
        "Typography",
        "Interactive elements",
        "Visual style",
        "None of the above"
      ]
    },
    {
      id: "feedback",
      text: "Please provide any additional feedback or suggestions for improvement.",
      type: "text"
    }
  ]
};

export default defaultConfig;